export default "__VITE_ASSET__ClNHU7Hd__"